import React from 'react'
import { Helmet } from 'react-helmet'

import { Header } from './Header'
import { EffectSection } from './EffectSection'
import { InitialSection } from './InitialSection'
import { CardWereHiring } from './CardWereHiring'
import { useTranslations } from "src/provider/LocaleProvider";

export const WereHiring = () => {
  const t = useTranslations()
    return (
        <>
            <Helmet>
                <title>{t('worldWile.helmet.title') ?? ''}</title>
                <meta
                    name="description"
                    content={t('worldWile.helmet.description') ?? ''}
                />
            </Helmet>

            <Header />
            <EffectSection viewTop={'0 20 40 99'} viewBottom={'0 20 40 99'} />
            <InitialSection />
            <CardWereHiring />
        </>
    )
}
